import {
  ADD_ALERT,
  CHANGE_TAB,
  CLEAR_ALERT,
  CLEAR_EMAILS,
  CLOSE_MODAL,
  OPEN_MODAL,
  UPDATE_EMAILS,
  UPDATE_FB_FRIENDS,
  UPDATE_FB_FRIEND_FOLLOWING_STATUS,
  UPDATE_INVITED_EMAILS_LIST
} from './InviteFriends.actions';

export function reducer(state, action) {
  switch (action.type) {
    case CLOSE_MODAL: {
      return { ...state, isModalOpen: false };
    }
    case OPEN_MODAL: {
      return { ...state, isModalOpen: true };
    }
    case UPDATE_EMAILS: {
      const { emails } = action.payload;
      return {
        ...state,
        emails
      };
    }

    case UPDATE_INVITED_EMAILS_LIST: {
      return {
        ...state,
        invitedEmailsList: [...state.invitedEmailsList, ...action.payload]
      };
    }

    case UPDATE_FB_FRIENDS: {
      const { fbFriends } = action.payload;
      return {
        ...state,
        fbFriends
      };
    }
    case UPDATE_FB_FRIEND_FOLLOWING_STATUS: {
      const { id, isFollowable, followingStatus } = action.payload;
      const friend = state.fbFriends[id];
      return {
        ...state,
        fbFriends: {
          ...state.fbFriends,
          [id]: { ...friend, isFollowable, followingStatus }
        }
      };
    }
    case ADD_ALERT: {
      const { alert } = action.payload;
      return {
        ...state,
        alert
      };
    }
    case CLEAR_ALERT: {
      return {
        ...state,
        alert: {}
      };
    }
    case CHANGE_TAB: {
      const { modalTabIndex } = action.payload;
      return { ...state, modalTabIndex };
    }
    case CLEAR_EMAILS: {
      return { ...state, emails: '' };
    }
    default: {
      throw new Error(`${action.type} - not recognized`);
    }
  }
}

export default { reducer };
